"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Fields_1 = require("Common/Form/Fields");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var PersonalDetails_1 = require("./PersonalDetails/PersonalDetails");
var CensusCollectorStore = (function () {
    function CensusCollectorStore(user, account, userListLength) {
        var _this = this;
        this.user = user;
        this.account = account;
        this.userListLength = userListLength;
        this.formFields = {};
        this.reactionDisposers = [];
        this.registerTriggerPulse = function (triggerPulse) {
            _this.reactionDisposers = [
                (0, mobx_1.reaction)(function () { return _this.userName; }, function () { return triggerPulse(); }),
                (0, mobx_1.reaction)(function () { return _this.getById(Fields_1.Password.id); }, function () { return triggerPulse(); }),
                (0, mobx_1.reaction)(function () { return _this.companyName; }, function () { return triggerPulse(); }),
                (0, mobx_1.reaction)(function () { return _this.salesTeamSize; }, function () { return triggerPulse(2.5); }),
                (0, mobx_1.reaction)(function () { return _this.getById(PersonalDetails_1.crmInUse.id); }, function () { return triggerPulse(3); }),
                (0, mobx_1.reaction)(function () { return _this.getById(PersonalDetails_1.userRoleField.id); }, function () { return triggerPulse(3); }),
            ];
        };
        this.unregisterTriggerPulse = function () {
            _this.reactionDisposers.forEach(function (dispose) { return dispose(); });
        };
        if (user.firstName) {
            var fullName = (0, GetFullName_1.default)({
                firstName: user.firstName,
                lastName: user.lastName,
            });
            this.setById(Fields_1.Name.id, fullName);
        }
        if (userListLength === 1) {
            if (account.phoneNumber) {
                this.setById(Fields_1.PhoneNumber.id, account.phoneNumber);
            }
            if (account.name != "Account Name") {
                this.setById(Fields_1.CompanyName.id, account.name);
            }
        }
    }
    CensusCollectorStore.prototype.getById = function (id) {
        return this.formFields[id] || "";
    };
    CensusCollectorStore.prototype.setById = function (id, value) {
        this.formFields[id] = value;
    };
    CensusCollectorStore.prototype.update = function (newValues) {
        this.formFields = __assign(__assign({}, this.formFields), newValues);
    };
    Object.defineProperty(CensusCollectorStore.prototype, "userName", {
        get: function () {
            return this.getById(Fields_1.Name.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "companyName", {
        get: function () {
            return this.getById(Fields_1.CompanyName.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "companySize", {
        get: function () {
            return this.getById(Fields_1.OptionGroupCompanySize.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CensusCollectorStore.prototype, "salesTeamSize", {
        get: function () {
            return this.getById(Fields_1.OptionGroupSalesTeamSize.id);
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof kaleidoscope_1.IFormValues !== "undefined" && kaleidoscope_1.IFormValues) === "function" ? _a : Object)
    ], CensusCollectorStore.prototype, "formFields", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "setById", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof kaleidoscope_1.IFormValues !== "undefined" && kaleidoscope_1.IFormValues) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], CensusCollectorStore.prototype, "update", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "userName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "companyName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "companySize", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CensusCollectorStore.prototype, "salesTeamSize", null);
    return CensusCollectorStore;
}());
exports.default = CensusCollectorStore;
